// extracted by mini-css-extract-plugin
module.exports = {"el":"index-module--el--16EGk","blue":"index-module--blue--25Qbu","outline":"index-module--outline--3r300","white":"index-module--white--34on0"};